class WbTwoColumns {
  constructor() {
    this.init();
  }

  init() {
    this.bindListeners();
  }

  bindListeners() {
    const _this = this;

    document
      .querySelectorAll('.wb-two-columns--accordion .wb-two-columns__toggle')
      ?.forEach((e) => e.addEventListener('click', _this.toggle.bind(_this)));
  }

  toggle(e) {
    const target = e.currentTarget;
    const content = target.closest('.wb-two-columns')?.querySelector('.wb-two-columns__content');

    target?._toggleAriaExpanded();
    content?._slideToggle();
  }
}

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    window.WbTwoColumns = new WbTwoColumns();
  }
});
